import React, {ReactNode} from "react";
import FunctionHelper from "../helper/FunctionHelper";
import PortalPureComponent from "./PortalPureComponent";

export enum PositionEnum {
	Custom = "custom",
	TopLeft = "top_left",
	TopCenter = "top_center",
	TopRight = "top_right",
	CenterLeft = "center_left",
	CenterCenter = "center_center",
	CenterRight = "center_right",
	BottomLeft = "bottom_left",
	BottomCenter = "bottom_center",
	BottomRight = "bottom_right"
}

interface PositionInputProperties {
	onChange?: (value: string) => void;
	value?: PositionEnum;
}

export default class PositionInput extends PortalPureComponent<PositionInputProperties, any> {
	/**
	 * render component as react node
	 */
	public render(): ReactNode {
		return (
			<div className="input-position">
				<span className={
					this.props.value === PositionEnum.TopLeft ? "active" : ""
				} onClick={() => {
					if (FunctionHelper.exists(this.props.onChange))
						this.props.onChange!(PositionEnum.TopLeft);
				}}/>
				<span className={
					this.props.value === PositionEnum.TopCenter ? "active" : ""
				} onClick={() => {
					if (FunctionHelper.exists(this.props.onChange))
						this.props.onChange!(PositionEnum.TopCenter);
				}}/>
				<span className={this.props.value === PositionEnum.TopRight ? "active" : ""}
					  onClick={() => {
						  if (FunctionHelper.exists(this.props.onChange))
							  this.props.onChange!(PositionEnum.TopRight);
					  }}/>
				<span className={this.props.value === PositionEnum.CenterLeft ? "active" : ""}
					  onClick={() => {
						  if (FunctionHelper.exists(this.props.onChange))
							  this.props.onChange!(PositionEnum.CenterLeft);
					  }}/>
				<span className={this.props.value === PositionEnum.CenterCenter ? "active" : ""}
					  onClick={() => {
						  if (FunctionHelper.exists(this.props.onChange))
							  this.props.onChange!(PositionEnum.CenterCenter);
					  }}/>
				<span className={this.props.value === PositionEnum.CenterRight ? "active" : ""}
					  onClick={() => {
						  if (FunctionHelper.exists(this.props.onChange))
							  this.props.onChange!(PositionEnum.CenterRight);
					  }}/>
				<span className={this.props.value === PositionEnum.BottomLeft ? "active" : ""}
					  onClick={() => {
						  if (FunctionHelper.exists(this.props.onChange))
							  this.props.onChange!(PositionEnum.BottomLeft);
					  }}/>
				<span className={this.props.value === PositionEnum.BottomCenter ? "active" : ""}
					  onClick={() => {
						  if (FunctionHelper.exists(this.props.onChange))
							  this.props.onChange!(PositionEnum.BottomCenter);
					  }}/>
				<span className={this.props.value === PositionEnum.BottomRight ? "active" : ""}
					  onClick={() => {
						  if (FunctionHelper.exists(this.props.onChange))
							  this.props.onChange!(PositionEnum.BottomRight);
					  }}/>
			</div>
		);
	}
}